import { Icon } from '@common/components';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import cx from 'classnames';
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import accordionClasses from './AccordionItem.module.scss';

export function AccordionItem({ children, className, headerClassName, label }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);

  const handleToggle = () => setOpen((prev) => !prev);

  const rootClasses = cx(className);
  const headerClasses = cx(accordionClasses.header, headerClassName);
  const contentClasses = cx(accordionClasses.content, {
    [accordionClasses.open]: open,
  });

  return (
    <div className={rootClasses}>
      <button
        className={headerClasses}
        onClick={handleToggle}
        aria-expanded={open}
        type="button"
      >
        {label}
        <Icon icon={open ? faAngleUp : faAngleDown} />
      </button>
      <div
        ref={contentRef}
        className={contentClasses}
        style={{
          maxHeight: open
            ? `${contentRef.current?.scrollHeight ?? 0}px`
            : '0px',
        }}
        aria-hidden={!open}
      >
        <div className={accordionClasses.inner}>{children}</div>
      </div>
    </div>
  );
}

AccordionItem.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
};
